// Round H — het seizoensbericht: één banner per seizoen, per gebruiker weg te klikken.
// Lezers doen niet mee aan het spel en zien de banner nooit.
export const kickoffKey = (userId, seasonId) => `tw1_season_kickoff_${userId}_${seasonId}`;

export function kickoffVisible(data, user, dismissedId, now = Date.now()) {
  const season = data?.season;
  if (!season?.id || !season.active) return false;
  if (!user?.id || user.role === "lezer") return false;
  const start = Date.parse(season.starts_at || "");
  const end = Date.parse(season.ends_at || "");
  if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
  if (now < start || now > end) return false;
  return dismissedId !== season.id;
}
